import { useAddCapability } from "../hooks/CapabilityHooks";
import { CapabilityDTO } from "../types/capabilityDTO";
import ValidationSummary from "../ValidationSummary";
import CapabilityForm from "./CapabilityForm";
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { useState } from "react";

const CapabilityAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const [capability, setCapability] = useState<CapabilityDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    organisationId: organisationId,
    name: "",
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
    specifier: 0
  });

  const addCapabilityMutation = useAddCapability(organisationId, setCapability);

  return (
    <>
      {addCapabilityMutation.isError && (
        <ValidationSummary error={addCapabilityMutation.error} />
      )}
      {addCapabilityMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('capability.addWait')}</p>
        </div>
      ) : (
        <CapabilityForm
          headerText={t('capability.add')}
          capability={capability}
          submitted={(capability) => {
            addCapabilityMutation.mutate(capability, {
              onError: () => {
                toast.error(t('capability.addError'));
              },
              onSuccess: () => {
                toast.success(t('capability.addSuccess'));
                history.back();
              }
            });
          }}
        />
      )}
    </>
  );
};

export default CapabilityAdd;